import httpClient from '@/helpers/axios';

export const postSmsAuthentication = async (
  phoneNumber: string
): Promise<unknown> => {
  return httpClient.post<unknown>(
    `/api/sms_authentication?PhoneNumber=${phoneNumber}`
  );
};

export const getConnectToken = async (
  response_type: string,
  client_id: string,
  scope: string,
  redirect_uri: string,
  PhoneNumber: string,
  SmsCode: number,
  nonce: number
): Promise<unknown> => {
  return httpClient.get<unknown>(
    `/connect/authorize?response_type=${response_type}&client_id=${client_id}&scope=${scope}&redirect_uri=${redirect_uri}&PhoneNumber=${PhoneNumber}&SmsCode=${SmsCode}&nonce=${nonce}&response_mode=form_post`,
    {
      headers: { 'content-type': 'application/x-www-form-urlencoded' },
    }
  );
};
